import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("App error:", error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.assign("/");
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[70vh] flex items-center justify-center px-6" data-testid="error-boundary">
          <div className="max-w-md w-full bg-[#141210] border border-[#2c2822] rounded-2xl p-10 text-center">
            <p className="text-[#c9a24b] text-xs tracking-[0.3em] uppercase mb-3">Kanama Naturals</p>
            <h1 className="font-display text-3xl text-[#f4efe4] mb-3">Something went wrong</h1>
            <p className="text-[#a29a8c] text-sm mb-8">
              We hit an unexpected snag. Please refresh and try again — your cart is safe.
            </p>
            <button
              onClick={this.handleReload}
              data-testid="error-reload-btn"
              className="btn-gold px-8 py-3 rounded-full text-sm tracking-[0.2em] uppercase font-medium"
            >
              Return Home
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
